import { Flex, Tabs, Text } from "@chakra-ui/react";
import { ReactNode } from "react";
import "./tab-element.css";

interface TabItem {
  value: string;
  label: string;
  icon?: ReactNode;
  content: ReactNode;
}

interface GenericTabsProps {
  tabs: TabItem[];
  defaultValue?: string;
  value?: string | null;
  onValueChange?: (details: any) => void;
  additionalButtons?: ReactNode;
}

export const TabComponent = ({
  tabs,
  defaultValue,
  onValueChange,
  value,
  additionalButtons,
}: GenericTabsProps) => {
  return (
    <Tabs.Root
      defaultValue={defaultValue ?? tabs[0]?.value}
      value={value}
      onValueChange={onValueChange}
    >
      <Tabs.List>
        {tabs.map((tab) => (
          <Tabs.Trigger paddingX="8px" key={tab.value} value={tab.value}>
            {tab.icon}
            <Text className="label">{tab.label}</Text>
          </Tabs.Trigger>
        ))}

        <Flex ml="auto" align="center" gap={2}>
          {additionalButtons}
        </Flex>
      </Tabs.List>

      {tabs.map((tab) => (
        <Tabs.Content key={tab.value} value={tab.value}>
          {tab.content}
        </Tabs.Content>
      ))}
    </Tabs.Root>
  );
};
